/** @format */

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { FormikProps } from 'formik';
import * as React from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectConstants } from './Api/constantSlice';
import { ErrorBox } from '../custom/ErrorBox';

interface Props {
  formik: FormikProps<any>;
  isDisabled: boolean;
}
export default function Gender({ formik, isDisabled }: Props) {
  const selData = useAppSelector(selectConstants);

  const genderEnums = (gender: string) => {
    switch (gender) {
      case 'Male':
        return 1;
      case 'Female':
        return 2;
      case 'Other':
        return 3;
      default:
        break;
    }
  };
  return (
    <>
      {selData.constantState && selData.constantState.gender && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={formik.touched.gender && Boolean(formik.errors.gender)}
              id='demo-select-small'>
              Gender
            </InputLabel>
            <Select
              name='gender'
              labelId='demo-select-small'
              id='demo-select-small'
              value={formik.values.gender}
              label='Gender'
              disabled={isDisabled}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={formik.touched.gender && Boolean(formik.errors.gender)}>
              <MenuItem value={0} disabled>
                Select Gender
              </MenuItem>
              {selData.constantState.gender.map((item: string, key: number) => {
                return (
                  <MenuItem key={key} value={genderEnums(item)}>
                    {item === 'Other' ? 'Prefer not to say' : item}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <ErrorBox>
          {formik.touched.gender && (formik.errors.gender as React.ReactNode)}
                                        </ErrorBox>
         
        </>
      )}
    </>
  );
}
